/* AudioWatt theme — global behaviors.
   Vanilla JS, no dependencies. Everything is keyboard accessible and
   announces state changes via #a11y-announcer. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function announce(text) {
    var region = document.getElementById('a11y-announcer');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(function () { region.textContent = text; }, 50);
  }
  window.themeAnnounce = announce;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------------------------------------------------------------------
     Drawers (mobile menu, cart drawer). Focus is moved in, trapped, and
     returned to the trigger on close. Escape closes.
     --------------------------------------------------------------------- */
  var openDrawer = null;
  var lastTrigger = null;

  function getFocusable(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function trapFocus(e) {
    if (!openDrawer || e.key !== 'Tab') return;
    var focusable = getFocusable(openDrawer);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  window.openThemeDrawer = function (id, trigger) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open');
    openDrawer = drawer;
    document.body.style.overflow = 'hidden';
    var focusable = getFocusable(drawer);
    if (focusable.length) focusable[0].focus();
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', window.closeThemeDrawer, { once: false });
    });
  };

  window.closeThemeDrawer = function () {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
    openDrawer = null;
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) window.closeThemeDrawer();
    trapFocus(e);
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      window.openThemeDrawer(opener.getAttribute('data-drawer-open'), opener);
    }
  });

  /* ---------------------------------------------------------------------
     Mega menu — click/Enter toggles; stays open while focus is inside;
     Escape closes and returns focus to the trigger.
     --------------------------------------------------------------------- */
  var megaStackOrder = 0; // most recently opened card floats to the top row
  document.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;

    function close() {
      panel.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function open() {
      // One card at a time: opening this one replaces whatever was showing.
      document.querySelectorAll('.mega-menu__panel[data-open]').forEach(function (other) {
        if (other === panel) return;
        other.removeAttribute('data-open');
        var t = document.querySelector('[data-mega-trigger][aria-controls="' + other.id + '"]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      panel.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
      var drop = panel.closest('.mega-menu__drop');
      if (drop) drop.style.order = --megaStackOrder;
    }

    trigger.addEventListener('click', function () {
      trigger.getAttribute('aria-expanded') === 'true' ? close() : open();
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); trigger.focus(); }
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    // Cards stack and persist: only the trigger itself (or Esc) closes one.
  });

  /* Mobile drawer: Car / Pro world tabs, mirrors the desktop mega switch */
  (function () {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer) return;
    var segs = drawer.querySelectorAll('[data-mob-seg]');
    segs.forEach(function (b) {
      b.addEventListener('click', function () {
        var name = b.getAttribute('data-mob-seg');
        segs.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        drawer.querySelectorAll('[data-mob-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-mob-panel') !== name;
        });
      });
    });
  })();

  /* Mobile menu sub-level toggles */
  document.querySelectorAll('.mobile-menu__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  /* ---------------------------------------------------------------------
     Tabs (product info tabs, delivery method tabs). Arrow-key navigation
     per WAI-ARIA tabs pattern.
     --------------------------------------------------------------------- */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var tabButtons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));

    function select(tab) {
      tabButtons.forEach(function (t) {
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        var selected = t === tab;
        t.setAttribute('aria-selected', String(selected));
        t.tabIndex = selected ? 0 : -1;
        if (panel) panel.hidden = !selected;
      });
    }

    tabButtons.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabButtons[(i + 1) % tabButtons.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabButtons[(i - 1 + tabButtons.length) % tabButtons.length];
        if (e.key === 'Home') next = tabButtons[0];
        if (e.key === 'End') next = tabButtons[tabButtons.length - 1];
        if (next) { e.preventDefault(); next.focus(); select(next); }
      });
    });
  });

  /* ---------------------------------------------------------------------
     Quantity inputs
     --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.quantity');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '1', 10);
    var value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------------
     Product gallery
     --------------------------------------------------------------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('.product__thumb');
    var items = gallery.querySelectorAll('.product__media-item');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-target');
        thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
        items.forEach(function (item) {
          item.classList.toggle('is-active', item.getAttribute('data-media-id') === id);
        });
        announce(thumb.getAttribute('aria-label') || 'Image changed');
      });
    });
  });

  /* ---------------------------------------------------------------------
     AJAX cart
     --------------------------------------------------------------------- */
  function refreshCartSections() {
    return fetch(window.themeRoutes.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawerContent');
        var current = document.querySelector('#CartDrawerContent');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        // The footer (subtotal / Checkout / View cart) lives outside
        // #CartDrawerContent and only exists server-side when the cart is
        // non-empty, so it must be added/replaced/removed explicitly.
        var panel = document.querySelector('#CartDrawer .drawer__panel');
        var freshFooter = doc.querySelector('#CartDrawer .drawer__footer');
        var currentFooter = panel && panel.querySelector('.drawer__footer');
        if (panel) {
          if (freshFooter && currentFooter) currentFooter.replaceWith(freshFooter);
          else if (freshFooter) panel.appendChild(freshFooter);
          else if (currentFooter) currentFooter.remove();
        }
        var freshCount = doc.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          if (freshCount) { el.textContent = freshCount.textContent; el.hidden = freshCount.textContent === '0'; }
        });
      });
  }
  window.refreshCartSections = refreshCartSections;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var submit = form.querySelector('[type="submit"]');
    // Icon-only buttons (quick add on cards) must keep their markup — swapping
    // textContent would wipe the icon and expose the screen-reader label.
    var isIconBtn = submit && submit.classList.contains('icon-button');
    var originalHTML = submit ? submit.innerHTML : '';
    if (submit) {
      submit.setAttribute('aria-disabled', 'true');
      if (isIconBtn) submit.classList.add('is-loading');
      else submit.textContent = window.themeStrings.loading;
    }

    fetch(window.themeRoutes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(form.querySelector('[name="id"]').value, 10),
          quantity: parseInt((form.querySelector('[name="quantity"]') || { value: 1 }).value, 10) || 1
        }]
      })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || window.themeStrings.cartError);
        announce(window.themeStrings.addedToCart);
        return refreshCartSections().then(function () {
          window.openThemeDrawer('CartDrawer', submit);
          if (typeof syncQuickAdds === 'function') syncQuickAdds();
        });
      })
      .catch(function (err) {
        var status = form.querySelector('[data-form-status]');
        if (status) { status.textContent = err.message; status.hidden = false; }
        announce(err.message);
      })
      .finally(function () {
        if (submit) {
          submit.removeAttribute('aria-disabled');
          if (isIconBtn) submit.classList.remove('is-loading');
          else submit.innerHTML = originalHTML;
        }
      });
  });

  /* Cart line quantity / remove (works on cart page + drawer) */
  function changeLine(line, quantity) {
    return fetch(window.themeRoutes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () {
      if (document.querySelector('[data-cart-page]')) { window.location.reload(); }
      else { refreshCartSections(); if (typeof syncQuickAdds === 'function') syncQuickAdds(); }
    });
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-qty]');
    if (input) changeLine(parseInt(input.getAttribute('data-cart-line-qty'), 10), parseInt(input.value, 10) || 0);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-line-remove]');
    if (btn) { e.preventDefault(); changeLine(parseInt(btn.getAttribute('data-cart-line-remove'), 10), 0); }
  });

  /* ---------------------------------------------------------------------
     Card quick-add ↔ cart sync: when a card's variant is already in the
     cart, show a − qty + stepper in place of the cart icon.
     --------------------------------------------------------------------- */
  function syncQuickAdds() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[data-ajax-cart]'))
      .filter(function (f) { return f.querySelector('.product-card__quick-add') || f.querySelector('[data-atc-button]'); });
    if (!forms.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (it) { inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity; });
        forms.forEach(function (form) {
          var idEl = form.querySelector('[name="id"]');
          if (!idEl) return;
          var variantId = parseInt(idEl.value, 10);
          var q = inCart[variantId] || 0;
          var isCard = !!form.querySelector('.product-card__quick-add');
          var btn = isCard ? form.querySelector('.product-card__quick-add') : form.querySelector('[data-atc-button]');
          if (!btn) return;
          var step = form.querySelector('[data-qa-step]');
          if (q > 0) {
            if (!step) {
              step = document.createElement('div');
              step.setAttribute('data-qa-step', '');
              step.className = isCard ? 'product-card__qa-step' : 'product-atc-step';
              step.innerHTML =
                '<button type="button" data-qa-minus aria-label="Remove one from cart">&minus;</button>' +
                (isCard
                  ? '<span data-qa-qty aria-live="polite"></span>'
                  : '<span class="product-atc-step__label">In cart: <b data-qa-qty aria-live="polite"></b></span>') +
                '<button type="button" data-qa-plus aria-label="Add one more to cart">+</button>';
              btn.parentNode.insertBefore(step, btn.nextSibling);
              var setQty = function (next) {
                step.classList.add('is-loading');
                var vid = parseInt(form.querySelector('[name="id"]').value, 10);
                fetch(window.themeRoutes.cart_change_url + '.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: String(vid), quantity: next })
                })
                  .then(function () { return refreshCartSections(); })
                  .catch(function () {})
                  .finally(function () { step.classList.remove('is-loading'); syncQuickAdds(); });
              };
              step.querySelector('[data-qa-minus]').addEventListener('click', function () {
                var cur = parseInt(step.querySelector('[data-qa-qty]').textContent, 10) || 0;
                setQty(Math.max(0, cur - 1));
              });
              step.querySelector('[data-qa-plus]').addEventListener('click', function () {
                var cur = parseInt(step.querySelector('[data-qa-qty]').textContent, 10) || 0;
                setQty(cur + 1);
              });
            }
            step.querySelector('[data-qa-qty]').textContent = q;
            step.hidden = false;
            btn.hidden = true;
          } else {
            if (step) step.hidden = true;
            btn.hidden = false;
          }
        });
      })
      .catch(function () {});
  }
  syncQuickAdds();
  // variant switch on the product page can cross in/out of the cart
  document.addEventListener('change', function (e) {
    if (e.target.closest('.variant-picker')) window.setTimeout(syncQuickAdds, 60);
  });

  /* ---------------------------------------------------------------------
     Variant picker — updates price, availability, SKU, URL; announces
     changes politely without moving focus.
     --------------------------------------------------------------------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);

    root.addEventListener('change', function (e) {
      if (!e.target.closest('.variant-picker')) return;
      var selected = [];
      root.querySelectorAll('.variant-picker fieldset').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) selected.push(checked.value);
      });
      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      var idInput = root.querySelector('[name="id"]');
      var button = root.querySelector('[data-atc-button]');
      var priceEl = root.querySelector('[data-price-current]');
      var skuEl = document.querySelector('[data-product-sku]');
      if (!match) {
        if (button) { button.disabled = true; button.textContent = window.themeStrings.unavailable; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (skuEl && match.sku) skuEl.textContent = match.sku;
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
      announce((match.title === 'Default Title' ? '' : match.title + '. ') + formatMoney(match.price) + (match.available ? '' : '. ' + window.themeStrings.soldOut));
    });
  });

  /* ---------------------------------------------------------------------
     Sticky add-to-cart bar — appears after the buy box scrolls out of view.
     --------------------------------------------------------------------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var buyBox = document.querySelector('[data-buy-box]');
  if (stickyBar && buyBox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      stickyBar.classList.toggle('is-visible', visible);
      document.body.classList.toggle('has-sticky-atc', visible);
    }, { threshold: 0 }).observe(buyBox);
  }

  /* ---------------------------------------------------------------------
     Order-cutoff countdown. Reads a real daily cutoff (HH:MM, store TZ
     offset provided server-side) — shows plain-text cutoff alongside;
     announces nothing per-second (aria-hidden ticker).
     --------------------------------------------------------------------- */
  /* We pick and pack Monday to Friday. A naive daily countdown promised
     same-day processing on Saturday and Sunday, which is a shipping claim we
     cannot honour, so the cutoff only counts down on a business day before
     the cutoff. Outside that it names the next business day instead. */
  document.querySelectorAll('[data-cutoff-line]').forEach(function (el) {
    var parts = el.getAttribute('data-countdown-cutoff').split(':');
    var labelEl = el.querySelector('[data-cutoff-label]');
    var tickerEl = el.querySelector('[data-cutoff-ticker]');
    var labelToday = el.getAttribute('data-label-today') || '';
    var labelNext = el.getAttribute('data-label-next') || '';
    var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    function isBiz(d) { return d.getDay() !== 0 && d.getDay() !== 6; }

    function tick() {
      /* Resolve Pacific via the IANA zone, not a fixed offset. The old
         data-tz-offset was hardcoded to -8, so the countdown ran an hour off
         for the eight months of the year that Pacific is on daylight time. */
      var storeNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
      var cutoff = new Date(storeNow);
      cutoff.setHours(parseInt(parts[0], 10), parseInt(parts[1] || '0', 10), 0, 0);

      if (isBiz(storeNow) && cutoff > storeNow) {
        var diff = cutoff - storeNow;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        if (labelEl) labelEl.textContent = labelToday;
        if (tickerEl) tickerEl.textContent = h + ' hr' + (h === 1 ? '' : 's') + ' ' + m + ' min' + (m === 1 ? '' : 's');
        return;
      }

      // Past today's cutoff, or a weekend: name the next business day.
      var next = new Date(storeNow);
      do { next.setDate(next.getDate() + 1); } while (!isBiz(next));
      if (labelEl) labelEl.textContent = labelNext.replace('__DAY__', DAYS[next.getDay()]);
      if (tickerEl) tickerEl.textContent = '';
    }
    tick();
    window.setInterval(tick, 30000);
  });

  /* ---------------------------------------------------------------------
     Cutoff-aware delivery estimate for air-shipped items.
     data-ship-eta="nextday" → 1 business day transit, "expedited" → 2.
     Ships same business day if ordered by 2 PM Pacific, else next business
     day. Computed client-side because pages are CDN-cached (a liquid date
     could be a stale render).
     --------------------------------------------------------------------- */
  document.querySelectorAll('[data-ship-eta]').forEach(function (el) {
    try {
      var transit = el.getAttribute('data-ship-eta') === 'nextday' ? 1 : 2;
      var ptNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
      function nextBiz(d) { do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6); }
      var ship = new Date(ptNow);
      if (ptNow.getHours() >= 14 || ship.getDay() === 0 || ship.getDay() === 6) nextBiz(ship);
      var eta = new Date(ship);
      for (var i = 0; i < transit; i++) nextBiz(eta);
      var dateStr = eta.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      var tpl = el.getAttribute('data-eta-template') || '__D__';
      var target = el.querySelector('[data-eta-text]') || el;
      target.textContent = tpl.replace('__D__', dateStr);
    } catch (e) { /* keep the server-rendered fallback */ }
  });

  /* ---------------------------------------------------------------------
     Hero slideshow — pausable, keyboard accessible, honors reduced motion.
     --------------------------------------------------------------------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero__slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero__dot'));
    var pauseBtn = root.querySelector('[data-slideshow-pause]');
    var autoplay = root.hasAttribute('data-autoplay') && !reducedMotion.matches;
    var interval = parseInt(root.getAttribute('data-interval') || '6000', 10);
    var index = 0;
    var timer = null;
    var userPaused = false; // explicit pause via the button — outlives hover stops

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', String(n === index)); });
    }
    function play() {
      if (!autoplay || userPaused) return;
      stop();
      timer = window.setInterval(function () { show(index + 1); }, interval);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function reflectPauseBtn() {
      if (!pauseBtn) return;
      pauseBtn.setAttribute('aria-pressed', String(userPaused));
      pauseBtn.setAttribute('aria-label', pauseBtn.getAttribute(userPaused ? 'data-label-play' : 'data-label-pause'));
    }

    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); stop(); }); });
    var prev = root.querySelector('.hero__arrow--prev');
    var next = root.querySelector('.hero__arrow--next');
    if (prev) prev.addEventListener('click', function () { show(index - 1); stop(); });
    if (next) next.addEventListener('click', function () { show(index + 1); stop(); });
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        if (userPaused) { stop(); } else { autoplay = true; play(); }
        reflectPauseBtn();
      });
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);

    var touchX = null;
    var touchY = null;
    root.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      touchX = touchY = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      show(index + (dx < 0 ? 1 : -1));
      stop();
    }, { passive: true });

    show(0);
    play();
  });

  /* ---------------------------------------------------------------------
     Announcement bar — on small screens rotate messages one at a time.
     --------------------------------------------------------------------- */
  (function () {
    var list = document.querySelector('.announcement-bar__items');
    if (!list || list.children.length < 2) return;
    var items = Array.prototype.slice.call(list.children);
    var mq = window.matchMedia('(max-width: 749px)');
    var idx = 0;
    var timer = null;

    function start() {
      if (timer) return;
      list.classList.add('is-rotating');
      items.forEach(function (li, n) { li.classList.toggle('is-shown', n === idx); });
      timer = window.setInterval(function () {
        idx = (idx + 1) % items.length;
        items.forEach(function (li, n) { li.classList.toggle('is-shown', n === idx); });
      }, 4000);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
      list.classList.remove('is-rotating');
      items.forEach(function (li) { li.classList.remove('is-shown'); });
    }
    function update() { if (mq.matches) start(); else stop(); }
    if (mq.addEventListener) mq.addEventListener('change', update);
    else if (mq.addListener) mq.addListener(update);
    update();
  })();

  /* ---------------------------------------------------------------------
     Predictive search — combobox pattern with results count announcements.
     --------------------------------------------------------------------- */
  document.querySelectorAll('[data-predictive-search]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="search"]');
    var panel = wrap.querySelector('.predictive-search');
    if (!input || !panel) return;
    var debounce = null;

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('autocomplete', 'off');

    input.addEventListener('input', function () {
      window.clearTimeout(debounce);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      debounce = window.setTimeout(function () {
        announce(window.themeStrings.loading);
        fetch(window.themeRoutes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var results = doc.querySelector('#PredictiveSearchResults');
            if (!results) return;
            panel.innerHTML = results.innerHTML;
            panel.hidden = false;
            input.setAttribute('aria-expanded', 'true');
            var count = panel.querySelectorAll('.predictive-search__item').length;
            announce(window.themeStrings.resultsCount.replace('[count]', count));
          });
      }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      if (panel.hidden) return;
      e.preventDefault();
      var links = Array.prototype.slice.call(panel.querySelectorAll('a'));
      if (!links.length) return;
      var current = links.indexOf(document.activeElement);
      var nextIndex = e.key === 'ArrowDown' ? current + 1 : current - 1;
      if (nextIndex < 0) { input.focus(); return; }
      if (links[nextIndex]) links[nextIndex].focus();
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { input.dispatchEvent(new KeyboardEvent('keydown', { key: e.key })); e.preventDefault(); }
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
  });

  /* ---------------------------------------------------------------------
     Facets — auto-submit filter form on change (progressive enhancement:
     works as a normal form without JS).
     --------------------------------------------------------------------- */
  document.querySelectorAll('[data-facets-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.id === 'SortBy') return; // sort is AJAX-handled by the collection section
      if (e.target.matches('input[type="checkbox"], select')) form.submit();
    });
  });
  /* Amazon-style price buckets — click applies the range (click again clears) */
  document.querySelectorAll('.facets__price-buckets').forEach(function (list) {
    var minName = list.getAttribute('data-price-min-name') || 'filter.v.price.gte';
    var maxName = list.getAttribute('data-price-max-name') || 'filter.v.price.lte';
    list.querySelectorAll('[data-price-bucket]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = new URLSearchParams(window.location.search);
        p.delete(minName);
        p.delete(maxName);
        p.delete('page');
        if (!btn.classList.contains('is-active')) {
          if (btn.dataset.min) p.set(minName, btn.dataset.min);
          if (btn.dataset.max) p.set(maxName, btn.dataset.max);
        }
        window.location.search = p.toString();
      });
    });
  });

  var facetsToggle = document.querySelector('[data-facets-toggle]');
  if (facetsToggle) {
    facetsToggle.addEventListener('click', function () {
      var facets = document.querySelector('.facets');
      var open = facets.classList.toggle('is-open-mobile');
      facetsToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------------------------------------------------------------------
     Recently viewed — localStorage ring buffer of product handles.
     --------------------------------------------------------------------- */
  try {
    var KEY = 'aw:recently-viewed';
    var meta = document.querySelector('[data-product-handle]');
    var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
    if (meta) {
      var handle = meta.getAttribute('data-product-handle');
      list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
      window.localStorage.setItem(KEY, JSON.stringify(list));
    }
    var container = document.querySelector('[data-recently-viewed]');
    if (container) {
      var exclude = container.getAttribute('data-exclude');
      var handles = list.filter(function (h) { return h !== exclude; }).slice(0, parseInt(container.getAttribute('data-limit') || '8', 10));
      if (!handles.length) {
        var section = container.closest('.shopify-section');
        if (section) section.hidden = true;
      } else {
        Promise.all(handles.map(function (h) {
          return fetch('/products/' + h + '?section_id=product-card-standalone').then(function (r) { return r.ok ? r.text() : ''; });
        })).then(function (cards) {
          container.innerHTML = cards.map(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var card = doc.querySelector('.product-card');
            return card ? card.outerHTML : '';
          }).join('');
        });
      }
    }
  } catch (err) { /* localStorage unavailable — feature silently off */ }

  /* ---------------------------------------------------------------------
     Reveal-on-scroll (respects reduced motion via CSS gate).
     --------------------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); revealObserver.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -40px' });
    document.querySelectorAll('.reveal').forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------------------------------------------------------------------
     Vehicle selector (garage) — stores the shopper's vehicle locally and
     filters collections via tag links. Fully form-based, no map required.
     --------------------------------------------------------------------- */
  try {
    var VKEY = 'aw:vehicle';
    var saved = JSON.parse(window.localStorage.getItem(VKEY) || 'null');
    document.querySelectorAll('[data-vehicle-value]').forEach(function (el) {
      if (saved) el.textContent = saved.year + ' ' + saved.make + ' ' + saved.model;
    });
    document.querySelectorAll('[data-vehicle-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = {
          year: form.querySelector('[name="vehicle-year"]').value,
          make: form.querySelector('[name="vehicle-make"]').value,
          model: form.querySelector('[name="vehicle-model"]').value
        };
        if (!v.year || !v.make || !v.model) return;
        window.localStorage.setItem(VKEY, JSON.stringify(v));
        document.querySelectorAll('[data-vehicle-value]').forEach(function (el) {
          el.textContent = v.year + ' ' + v.make + ' ' + v.model;
        });
        announce('Vehicle saved: ' + v.year + ' ' + v.make + ' ' + v.model);
        var modal = form.closest('dialog');
        if (modal) modal.close();
      });
    });
  } catch (err) { /* no-op */ }

  /* Modal openers for <dialog> */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-modal-open'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    }
    var closer = e.target.closest('[data-modal-close]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) d.close();
    }
  });
})();

/* Search category scoping + mega-menu subcategory flyout */
(function () {
  'use strict';

  // Category dropdown: scope the search by appending the category terms
  document.querySelectorAll('[data-search-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var select = form.querySelector('[data-search-category]');
      var input = form.querySelector('input[type="search"]');
      if (select && select.value && input) {
        input.value = (input.value + ' ' + select.value).trim();
      }
    });
  });

  // Mega menu: hovering/focusing a main category reveals its subcategories
  document.querySelectorAll('#MegaMenuPanel').forEach(function (panel) {
    var cats = panel.querySelectorAll('[data-mega-cat]');
    var panels = panel.querySelectorAll('[data-mega-panel]');
    function activate(index) {
      cats.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-mega-cat') === index); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-mega-panel') === index); });
    }
    cats.forEach(function (cat) {
      var index = cat.getAttribute('data-mega-cat');
      cat.addEventListener('pointerenter', function () { activate(index); });
      cat.addEventListener('focus', function () { activate(index); });
    });
    // Car Audio / Pro Audio world switch: swap the rail, the side column,
    // and land on the first category of the chosen world.
    var segs = panel.querySelectorAll('[data-mega-seg]');
    var segLists = panel.querySelectorAll('[data-mega-seglist]');
    var segOnly = panel.querySelectorAll('[data-mega-segonly]');
    function setSeg(name) {
      segs.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-mega-seg') === name); });
      segLists.forEach(function (l) { l.hidden = l.getAttribute('data-mega-seglist') !== name; });
      segOnly.forEach(function (d) { d.hidden = d.getAttribute('data-mega-segonly') !== name; });
      panel.querySelectorAll('[data-mega-segtitle]').forEach(function (t) {
        var txt = t.getAttribute('data-title-' + name);
        if (txt) t.textContent = txt;
      });
      var first = panel.querySelector('[data-mega-seglist="' + name + '"] [data-mega-cat]');
      if (first) activate(first.getAttribute('data-mega-cat'));
    }
    segs.forEach(function (b) {
      b.addEventListener('click', function () { setSeg(b.getAttribute('data-mega-seg')); });
    });
  });
})();

/* Custom styled category dropdown (progressive enhancement over the <select>) */
(function () {
  'use strict';
  document.querySelectorAll('[data-search-form] [data-search-category]').forEach(function (select) {
    var wrap = document.createElement('div');
    wrap.className = 'cat-dropdown';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'cat-dropdown__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-haspopup', 'true');
    toggle.innerHTML = '<span class="cat-dropdown__label"></span>' +
      '<svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
    var label = toggle.querySelector('.cat-dropdown__label');

    var panel = document.createElement('div');
    panel.className = 'cat-dropdown__panel';
    panel.hidden = true;

    var items = [];
    function addItem(option, container) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cat-dropdown__item';
      btn.textContent = option.textContent;
      btn.setAttribute('aria-pressed', String(option.selected));
      btn.addEventListener('click', function () {
        select.value = option.value;
        items.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        label.textContent = option.textContent;
        close();
        toggle.focus();
      });
      items.push(btn);
      container.appendChild(btn);
    }

    Array.prototype.forEach.call(select.children, function (child) {
      if (child.tagName === 'OPTGROUP') {
        var group = document.createElement('div');
        group.className = 'cat-dropdown__group';
        var groupLabel = document.createElement('div');
        groupLabel.className = 'cat-dropdown__group-label';
        groupLabel.textContent = child.label;
        group.appendChild(groupLabel);
        Array.prototype.forEach.call(child.children, function (opt) { addItem(opt, group); });
        panel.appendChild(group);
      } else {
        var all = document.createElement('div');
        all.className = 'cat-dropdown__group cat-dropdown__group--all';
        addItem(child, all);
        panel.appendChild(all);
      }
    });

    label.textContent = select.options[select.selectedIndex] ? select.options[select.selectedIndex].textContent : 'All Categories';

    function open() { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
    function close() { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }

    toggle.addEventListener('click', function () { panel.hidden ? open() : close(); });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); toggle.focus(); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var idx = items.indexOf(document.activeElement);
        var next = e.key === 'ArrowDown' ? idx + 1 : idx - 1;
        if (items[next]) items[next].focus();
      }
    });
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); open(); if (items[0]) items[0].focus(); }
      if (e.key === 'Escape') close();
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });

    select.hidden = true;
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(toggle);
    wrap.appendChild(panel);
  });
})();

/* Product image lightbox — click image/zoom to enlarge, arrows to navigate */
(function () {
  'use strict';
  var dialog = document.getElementById('ProductLightbox');
  var gallery = document.querySelector('[data-gallery]');
  if (!dialog || !gallery) return;

  var imgEl = dialog.querySelector('[data-lightbox-img]');
  var counter = dialog.querySelector('[data-lightbox-counter]');
  var sources = [];
  gallery.querySelectorAll('.product__media-item img[data-full]').forEach(function (img) {
    sources.push({ full: img.getAttribute('data-full'), alt: img.alt });
  });
  if (!sources.length) return;
  var index = 0;

  function show(i) {
    index = (i + sources.length) % sources.length;
    imgEl.src = sources[index].full;
    imgEl.alt = sources[index].alt;
    counter.textContent = (index + 1) + ' / ' + sources.length;
  }
  function activeIndex() {
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    var active = gallery.querySelector('.product__media-item.is-active img[data-full]');
    var imgs = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item img[data-full]'));
    var activeImg = active || imgs[0];
    return Math.max(0, imgs.indexOf(activeImg));
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lightbox-open]');
    if (!opener) return;
    show(activeIndex());
    dialog.showModal();
  });
  dialog.querySelector('[data-lightbox-prev]').addEventListener('click', function () { show(index - 1); });
  dialog.querySelector('[data-lightbox-next]').addEventListener('click', function () { show(index + 1); });
  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') show(index - 1);
    if (e.key === 'ArrowRight') show(index + 1);
  });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
})();

/* Preload all hero slide images so rotation never shows a blank frame */
(function () {
  'use strict';
  function preload() {
    document.querySelectorAll('[data-slideshow] .hero__slide img').forEach(function (img) {
      var warm = new Image();
      if (img.srcset) warm.srcset = img.srcset;
      if (img.sizes) warm.sizes = img.sizes;
      warm.src = img.currentSrc || img.src;
    });
  }
  if (document.readyState === 'complete') preload();
  else window.addEventListener('load', preload);
})();

/* Auto-slide product carousels (.scroll-row): advances one card every few
   seconds, loops, pauses on hover/focus/touch, only while visible,
   disabled for reduced-motion users. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Drag-to-scroll for any horizontal row. Returns isDragging checker. */
  function makeDraggable(el) {
    var down = false, dragged = false, startX = 0, startLeft = 0;
    el.style.cursor = 'grab';
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return; // touch scrolls natively
      down = true; dragged = false;
      startX = e.clientX; startLeft = el.scrollLeft;
      el.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) dragged = true;
      el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      down = false;
      el.style.cursor = 'grab';
    });
    el.addEventListener('click', function (e) {
      if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
    }, true);
    return function () { return down; };
  }
  window.awMakeDraggable = makeDraggable;

  document.querySelectorAll('.scroll-row').forEach(function (row) {
    if (row.children.length < 3) return;
    if (row.classList.contains('scroll-row--nav')) return; // arrow-nav rows are static
    row.style.scrollSnapType = 'none'; // snap fights the continuous drift
    var isDragging = makeDraggable(row);
    var paused = false;
    var visible = false;
    var resting = 0;
    var SPEED = 0.28; // px per frame ≈ 17px/s — slow, relaxed drift

    function frame() {
      if (!paused && !row.awDragging && visible && resting <= 0) {
        var maxScroll = row.scrollWidth - row.clientWidth;
        if (maxScroll > 4) {
          if (row.scrollLeft >= maxScroll - 1) {
            resting = 90; // brief pause, then glide back to start
            row.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            row.scrollLeft += SPEED;
          }
        }
      } else if (resting > 0) {
        resting--;
      }
      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);

    ['pointerenter', 'focusin', 'touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      row.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    ['pointerleave', 'focusout'].forEach(function (ev) {
      row.addEventListener(ev, function () { paused = false; });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.35 }).observe(row);
    } else {
      visible = true;
    }
  });
})();

/* Arrow-nav rows (.category-row-wrap): static scrollable rows — category
   circles and product carousels alike. No auto-slide, no cloning —
   prev/next arrows page through the cards, drag/swipe still works. */
(function () {
  'use strict';
  document.querySelectorAll('.category-row-wrap').forEach(function (wrap) {
    var row = wrap.querySelector('.category-row, .scroll-row');
    if (!row) return;
    // .scroll-row gets drag from attachDrag below; category rows need it here
    if (row.classList.contains('category-row') && window.awMakeDraggable) window.awMakeDraggable(row);

    var prev = wrap.querySelector('[data-row-nav="-1"]');
    var next = wrap.querySelector('[data-row-nav="1"]');

    function updateArrows() {
      var max = row.scrollWidth - row.clientWidth;
      if (prev) prev.classList.toggle('is-hidden', row.scrollLeft <= 2);
      if (next) next.classList.toggle('is-hidden', row.scrollLeft >= max - 2);
    }
    updateArrows();
    row.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    // Recommendations / recently-viewed rows fill after load — re-check overflow
    if ('MutationObserver' in window) new MutationObserver(updateArrows).observe(row, { childList: true });

    wrap.querySelectorAll('[data-row-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!row.children.length) return;
        var dir = parseInt(btn.getAttribute('data-row-nav'), 10) || 1;
        var gap = parseFloat(window.getComputedStyle(row).columnGap) || 0;
        var step = (row.children[0].offsetWidth + gap) * 3 * dir;
        row.scrollBy({ left: step, behavior: 'smooth' });
      });
    });
  });
})();

/* Hover-intent open for dropdown triggers marked data-hover-open */
(function () {
  'use strict';
  document.querySelectorAll('[data-hover-open]').forEach(function (trigger) {
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    var closeTimer = null;
    function cancel() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }
    function scheduleClose() {
      cancel();
      closeTimer = setTimeout(function () {
        if (trigger.getAttribute('aria-expanded') === 'true') trigger.click();
      }, 220);
    }
    trigger.addEventListener('pointerenter', function () {
      cancel();
      if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
    });
    trigger.addEventListener('pointerleave', scheduleClose);
    panel.addEventListener('pointerenter', cancel);
    panel.addEventListener('pointerleave', scheduleClose);
  });
})();

/* My Garage — saved vehicles with active selection, powered by the fitment DB */
(function () {
  'use strict';
  var modal = document.querySelector('[data-garage]');
  if (!modal) return;
  var garageView = modal.querySelector('[data-garage-view]');
  var addView = modal.querySelector('[data-add-view]');
  var listEl = modal.querySelector('[data-garage-list]');
  var titleEl = modal.querySelector('[data-garage-title]');
  var yearSel = modal.querySelector('[data-gv-year]');
  var makeSel = modal.querySelector('[data-gv-make]');
  var modelSel = modal.querySelector('[data-gv-model]');
  var saveBtn = modal.querySelector('[data-garage-save]');
  var backBtn = modal.querySelector('[data-garage-back]');
  var data = null;

  function lsGet(k, fallback) { try { return JSON.parse(localStorage.getItem(k)) || fallback; } catch (e) { return fallback; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function vehName(v) { return v.year + ' ' + v.make + ' ' + v.model; }
  function getGarage() {
    var g = lsGet('aw:garage', null);
    if (!g) { var single = lsGet('aw:vehicle', null); g = single ? [single] : []; }
    return g;
  }
  function updateHeaderLabels() {
    var active = lsGet('aw:vehicle', null);
    document.querySelectorAll('[data-vehicle-value]').forEach(function (el) {
      // Remember each slot's placeholder so clearing the garage can restore it.
      if (!el.hasAttribute('data-veh-default')) el.setAttribute('data-veh-default', el.textContent);
      el.textContent = active ? vehName(active) : el.getAttribute('data-veh-default');
    });
  }

  /* Account sync: logged-in customers keep their garage on their customer record */
  window.awGarageSync = (function () {
    var t;
    return function () {
      var c = window.awCustomer;
      if (!c || !c.id) return;
      clearTimeout(t);
      t = setTimeout(function () {
        try {
          // App proxy: same-origin and HMAC-signed by Shopify, so the backend
          // takes the customer id from the signed request, not from us.
          fetch('/apps/adw-account?action=garage_save', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'garage=' + encodeURIComponent(JSON.stringify({
              vehicles: lsGet('aw:garage', []),
              active: lsGet('aw:vehicle', null)
            }))
          }).then(function (r) {
            if (!r.ok) console.warn('garage sync failed:', r.status);
          }).catch(function (e) { console.warn('garage sync failed:', e); });
        } catch (e) {}
      }, 800);
    };
  })();
  /* Sign-out / account switch: the garage belongs to whoever was signed in, so
     drop the local copy the moment the signed-in identity changes. Runs BEFORE
     the cloud merge, otherwise the previous customer's cars would be pushed
     into the new account. Pure guests keep theirs — they never had an account
     copy to leak onto a shared computer. */
  (function resetGarageOnIdentityChange() {
    var cur = (window.awCustomer && window.awCustomer.id) ? String(window.awCustomer.id) : '';
    var prev = '';
    try { prev = localStorage.getItem('aw:cust') || ''; } catch (e) {}
    if (prev && prev !== cur) {
      try {
        localStorage.removeItem('aw:garage');
        localStorage.removeItem('aw:vehicle');
        localStorage.removeItem('aw:rig');
      } catch (e) {}
    }
    try {
      if (cur) localStorage.setItem('aw:cust', cur);
      else localStorage.removeItem('aw:cust');
    } catch (e) {}
  })();

  /* My Rig: same account-follows-you model as the garage. */
  window.awRigSync = (function () {
    var t;
    return function () {
      var c = window.awCustomer;
      if (!c || !c.id) return;
      clearTimeout(t);
      t = setTimeout(function () {
        try {
          fetch('/apps/adw-account?action=rig_save', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'rig=' + encodeURIComponent(JSON.stringify(lsGet('aw:rig', { items: [] })))
          }).then(function (r) {
            if (!r.ok) console.warn('rig sync failed:', r.status);
          }).catch(function (e) { console.warn('rig sync failed:', e); });
        } catch (e) {}
      }, 800);
    };
  })();

  (function mergeCloudRig() {
    var c = window.awCustomer;
    if (!c || !c.rig || !c.rig.items) return;
    var local = lsGet('aw:rig', { items: [] });
    var seen = {}, merged = [];
    (local.items || []).concat(c.rig.items).forEach(function (it) {
      if (!it || !it.cat) return;
      var k = it.cat + '|' + (it.name || '');
      if (seen[k]) return;
      seen[k] = 1; merged.push(it);
    });
    if (merged.length) lsSet('aw:rig', { items: merged });
    if (merged.length !== c.rig.items.length) window.awRigSync();
  })();

  (function mergeCloudGarage() {
    var c = window.awCustomer;
    if (!c || !c.garage) return;
    var cloud = (c.garage && c.garage.vehicles) || [];
    var seen = {}, merged = [];
    getGarage().concat(cloud).forEach(function (v) {
      if (!v || !v.year || !v.make || !v.model) return;
      var k = vehName(v);
      if (seen[k]) return;
      seen[k] = 1; merged.push(v);
    });
    if (merged.length) lsSet('aw:garage', merged);
    if (!lsGet('aw:vehicle', null) && c.garage.active) lsSet('aw:vehicle', c.garage.active);
    updateHeaderLabels();
    if (merged.length !== cloud.length) window.awGarageSync();
  })();

  /* Public make/model/year index only — fitment itself is never bulk loaded.
     See snippets/vehicle-data.liquid. */
  function load() {
    if (data) return Promise.resolve(data);
    return window.AWVehicles.load().then(function (idx) { data = idx; return data; });
  }
  function fill(select, values) {
    var ph = select.options[0].text;
    select.innerHTML = '<option value="">' + ph + '</option>' +
      values.map(function (v) { return '<option>' + v + '</option>'; }).join('');
    select.disabled = values.length === 0;
  }

  function showAdd() {
    garageView.hidden = true;
    addView.hidden = false;
    backBtn.hidden = getGarage().length === 0;
    titleEl.textContent = modal.getAttribute('data-title-add') || 'Add a vehicle';
    load().then(function () {
      if (yearSel.options.length <= 1) fill(yearSel, window.AWVehicles.years(data));
    });
  }

  function showGarage() {
    var garage = getGarage();
    if (!garage.length) { showAdd(); return; }
    titleEl.textContent = modal.getAttribute('data-title-garage') || 'My Garage';
    addView.hidden = true;
    garageView.hidden = false;
    var active = lsGet('aw:vehicle', null);
    listEl.innerHTML = garage.map(function (v, i) {
      var isActive = active && vehName(active) === vehName(v);
      return '<li class="garage__item' + (isActive ? ' is-active' : '') + '">' +
        '<button type="button" class="garage__pick" data-garage-pick="' + i + '">' +
          '<svg class="icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 16v3h2.5v-2h11v2H20v-3M4 16l1.5-6a2 2 0 0 1 2-1.5h9a2 2 0 0 1 2 1.5L20 16M4 16h16"/></svg>' +
          '<span><strong>' + vehName(v) + '</strong>' + (isActive ? '<em class="garage__active-tag">Active</em>' : '') + '</span>' +
        '</button>' +
        '<a class="garage__fits" href="/#vehicle-finder" data-garage-fits="' + i + '">Fits</a>' +
        '<button type="button" class="icon-button garage__remove" data-garage-remove="' + i + '" aria-label="Remove ' + vehName(v) + '">' +
          '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19"/></svg>' +
        '</button></li>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-modal-open="VehicleModal"]')) showGarage();
    var pick = e.target.closest('[data-garage-pick]');
    if (pick) {
      var v = getGarage()[parseInt(pick.getAttribute('data-garage-pick'), 10)];
      lsSet('aw:vehicle', v); updateHeaderLabels(); showGarage(); window.awGarageSync();
    }
    var fits = e.target.closest('[data-garage-fits]');
    if (fits) {
      var fv = getGarage()[parseInt(fits.getAttribute('data-garage-fits'), 10)];
      lsSet('aw:vehicle', fv); updateHeaderLabels(); modal.close(); window.awGarageSync();
    }
    var rm = e.target.closest('[data-garage-remove]');
    if (rm) {
      var g = getGarage();
      var removed = g.splice(parseInt(rm.getAttribute('data-garage-remove'), 10), 1)[0];
      lsSet('aw:garage', g);
      window.awGarageSync();
      var active = lsGet('aw:vehicle', null);
      if (active && removed && vehName(active) === vehName(removed)) {
        if (g.length) { lsSet('aw:vehicle', g[0]); } else { try { localStorage.removeItem('aw:vehicle'); } catch (err) {} }
        updateHeaderLabels();
      }
      showGarage();
    }
    if (e.target.closest('[data-garage-add]')) showAdd();
    if (e.target.closest('[data-garage-back]')) showGarage();
  });

  yearSel.addEventListener('change', function () {
    saveBtn.disabled = true;
    var y = yearSel.value;
    if (!y) { fill(makeSel, []); fill(modelSel, []); return; }
    fill(makeSel, window.AWVehicles.makes(data, y)); fill(modelSel, []);
  });
  makeSel.addEventListener('change', function () {
    saveBtn.disabled = true;
    var y = yearSel.value, m = makeSel.value;
    if (!m) { fill(modelSel, []); return; }
    fill(modelSel, window.AWVehicles.models(data, y, m));
  });
  modelSel.addEventListener('change', function () { saveBtn.disabled = !modelSel.value; });
  saveBtn.addEventListener('click', function () {
    var v = { year: yearSel.value, make: makeSel.value, model: modelSel.value };
    if (!v.year || !v.make || !v.model) return;
    var g = getGarage();
    if (!g.some(function (x) { return vehName(x) === vehName(v); })) g.push(v);
    lsSet('aw:garage', g);
    lsSet('aw:vehicle', v);
    updateHeaderLabels();
    window.awGarageSync();
    if (window.themeAnnounce) window.themeAnnounce('Vehicle saved: ' + vehName(v));
    showGarage();
  });

  updateHeaderLabels();
})();

/* Brand marquee: JS-driven seamless loop + mouse drag (CSS animation is the
   no-JS fallback; we disable it here and drive scrollLeft instead). */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.brand-marquee').forEach(function (marquee) {
    var track = marquee.querySelector('.brand-marquee__track');
    var sets = marquee.querySelectorAll('.brand-marquee__set');
    if (!track || sets.length < 2) return;
    marquee.classList.add('js-marquee');
    track.style.animation = 'none';

    var isDragging = window.awMakeDraggable ? window.awMakeDraggable(marquee) : function () { return false; };
    var paused = false;
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
      marquee.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    ['pointerleave', 'focusout'].forEach(function (ev) {
      marquee.addEventListener(ev, function () { paused = false; });
    });

    function frame() {
      var setWidth = sets[0].offsetWidth;
      if (setWidth > 0) {
        if (!paused && !isDragging() && !reduced) marquee.scrollLeft += 0.6;
        // seamless wrap in both directions (drag can go backwards)
        if (marquee.scrollLeft >= setWidth) marquee.scrollLeft -= setWidth;
        else if (marquee.scrollLeft < 0) marquee.scrollLeft += setWidth;
      }
      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  });
})();

/* Drag-to-scroll for product rows + seamless draggable brand marquee */
(function () {
  'use strict';

  function attachDrag(el) {
    var startX = 0, startScroll = 0, moved = 0, down = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return; // touch scrolls natively
      down = true; moved = 0;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      el.classList.add('aw-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      if (moved > 4) {
        el.awDragging = true;
        el.scrollLeft = startScroll - dx;
        e.preventDefault();
      }
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      el.classList.remove('aw-dragging');
      window.setTimeout(function () { el.awDragging = false; }, 50);
    });
    // Suppress accidental link clicks after a real drag
    el.addEventListener('click', function (e) {
      if (moved > 8) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);
    el.querySelectorAll('img').forEach(function (img) { img.draggable = false; });
  }

  document.querySelectorAll('.scroll-row').forEach(attachDrag);

  document.querySelectorAll('.brand-marquee').forEach(function (marquee) {
    var track = marquee.querySelector('.brand-marquee__track');
    if (!track) return;
    marquee.classList.add('js-scroll'); // switches CSS animation off, scroll on
    attachDrag(marquee);
    var paused = false;
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
      marquee.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    ['pointerleave', 'focusout'].forEach(function (ev) {
      marquee.addEventListener(ev, function () { paused = false; });
    });
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function wrap() {
      var setW = track.scrollWidth / 2;
      if (setW <= 0) return;
      if (marquee.scrollLeft >= setW) marquee.scrollLeft -= setW;
      if (marquee.scrollLeft < 0) marquee.scrollLeft += setW;
    }
    function frame() {
      if (!reduced && !paused && !marquee.awDragging) marquee.scrollLeft += 0.35;
      wrap();
      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  });
})();

/* v2 */
